import { packageNameFromSpec } from '@next-adapter/package-json/package-name-from-spec.js'
import { getAlignedPackageSpec } from './get-aligned-package-spec.js'

export function alignDependencySpecs(dependencies: string[]): string[] {
  return dependencies.map((dependency) => {
    const name = packageNameFromSpec(dependency)
    return getAlignedPackageSpec(name) ?? dependency
  })
}
